import { render, staticRenderFns } from "./SettingsDifferences.vue?vue&type=template&id=33d997dc&"
import script from "./SettingsDifferences.vue?vue&type=script&lang=js&"
export * from "./SettingsDifferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/SettingsDifferences.vue
// module id = null
// module chunks = 